import React, { useEffect } from "react";
import "../Styles/Reviews.css";

const Reviews = () => {
  useEffect(() => {
    const wrapper = document.querySelector(".responsive-widget-wrapper");
    if (!wrapper) return;

    const script = document.createElement("script");
    script.src = "https://cdn.trustindex.io/loader.js?eeb0628506398159e8062579d76";
    script.defer = true;
    script.async = true;
    wrapper.appendChild(script);

    return () => {
      if (wrapper.contains(script)) {
        wrapper.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="reviews-section">
      <div className="container reviews-container">
        <p className="eyebrow reveal">Social proof</p>
        <h2 className="section-title reviews-heading reveal">Parents see the difference</h2>
        <p className="reviews-lead reveal">
          Real feedback from families who wanted clearer understanding, stronger confidence,
          and a tutoring experience they could trust.
        </p>
        <div className="reviews-link reveal">
          <a
            className="btn btn-secondary"
            href="https://g.co/kgs/LydXvQq"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Google Reviews
          </a>
        </div>
        <div className="responsive-widget-wrapper reveal">
          {/* Trustindex widget injects here */}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
